
<app-header></app-header>
<div class="newHome" translate="no">
    <section class="hero">
        <div class="container">
            <div class="row">
                <div class="col-sm-5">
                     <div class="text-end logoSec">
                        <img src="/assets/images/kisan_logo_white.png" alt="KISAN Logo" class="logoK" />
                        <h4 class="mb-1">९ - १३ डिसेंबर २०२६ पुणे</h4>
                        <h5>सकाळी ९ ते संध्याकाळी ५</h5>
                    </div>
                </div>
                <div class="col-sm-2"></div>
                <div class="col-sm-5">
                    <div>
                        <img class="w-100" src="/assets/images/me/tag_logo_mr.png" alt="Logo" />
                        <p class="mt-4 line">भारतभरातून येणाऱ्या २ लाखाहून अधिक शेतकरी आणि ६०० पेक्षा जास्त
                            प्रदर्शनकर्त्यांमध्ये सामील व्हा! अत्याधुनिक कृषी तंत्रज्ञान, स्मार्ट शेती आणि नेटवर्किंगची
                            संधी एकाच ठिकाणी अनुभवा!
                        </p>
                        <div class="mt-4" *ngIf="showBuyTicketButton">
                            <a class="button tktBook" (click)="onBuyTickets()">
                                <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" />  -->
                                    तिकीट बुक करा
                                <span><i class="fa fa-arrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pavilion-wrapper" [ngClass]="{'d-none': hidePavilionSection}" *ngIf="eventDetails?.show_digital_catalog">
                <div class="layout d-flex justify-content-between flex-column flex-md-row">
                    <h3 class="tit text-white">KISAN Pavilions </h3>
                       
                </div>
                
                <div class="mSection d-flex" *ngIf="!isLoadingPavilions && allPavilions?.length">
                    <div class="grp pragati">
                        <div class="pGrp">
                            <div class="sng" *ngFor="let pavilion of allPavilions">
                                <div class="img-Wrapper">
                                    <img [src]="pavilion.image_url" [alt]="pavilion.name"
                                    (click)="onClickCatalog(pavilion)"
                                    (keydown.enter)="onClickCatalog(pavilion)"
                                    tabindex="0"
                                    role="button"/>
                                </div>
                                <h6 class="text-center mt-2 text-white"
                                    (click)="onClickCatalog(pavilion)"
                                    (keydown.enter)="onClickCatalog(pavilion)"
                                    tabindex="0"
                                    role="button">{{ pavilion.name }}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-loader text-left" *ngIf="isLoadingPavilions">
                    <div class="spinner-border text-success" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>           
        </div>

        <div class="actBtn text-center mt-4 d-flex justify-content-center align-items-center flex-column flex-md-row">
            <a class="button" (click)="onBuyTickets()" *ngIf="showBuyTicketButton">
                <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                तिकीट बुक करा
                <span><i class="fa fa-arrow-right"></i></span>
            </a>
            
            <a class="button catalogLink" routerLink="/catalogue/pavilion-list" *ngIf="eventDetails?.show_digital_catalog">
                <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                कॅटलॉग पहा
                <span><i class="fa fa-arrow-right"></i></span>
            </a>
        </div>
    </section>

    <section>
        <div class="container">
            <video #homeVideo autoplay muted loop playsinline preload="auto" width="100%">
                <source src="/assets/images/me/details_video.mp4" type="video/mp4">
            </video>
        </div>
    </section>

    <section class="attend">
        <div class="container">
            <div class="gprMain">
                <div class="row grp">
                    <div class="col-md-6">
                        <div class="sec tagLine">
                            <!-- <h3 class="font-weight-600">Why Attend</h3> -->
                            <h1 class="green">किसान २०२६ ला<br> का भेट द्यावी?</h1>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec">
                            <img src="/assets/images/me/exhibitor.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">६०० पेक्षा जास्त कंपन्यांचा सहभाग</h5>
                            <p>भारतातील अग्रगण्य कृषी ब्रँड्स आणि उत्पादकांना भेटा</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec">
                            <img src="/assets/images/me/users.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">२ लाखाहून अधिक शेतकरी</h5>
                            <p>देशभरातील शेतकरी, उद्योजक आणि कृषीप्रेमी एका व्यासपीठावर</p>
                        </div>
                    </div>
                </div>

                <div class="row grp">
                    <div class="col-md-3">
                        <div class="sec">
                            <img src="/assets/images/me/productsicon.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">२,०००+ कृषी उत्पादने व सेवा</h5>
                            <p>अत्याधुनिक साधने आणि तंत्रज्ञान प्रत्यक्ष पहा</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec">
                            <img src="/assets/images/me/network.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">नेटवर्किंगच्या संधी</h5>
                            <p>कृषी व उद्योग क्षेत्रातल्या मान्यवरांशी जोडले जा</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="sec PavilionSlider">
                            <div class="compInterest">
                                <div class="containerd">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <h5 class="font-weight-600 mt-3 mb-4">१२ विशेष दालनं</h5>
                                        <a class="catalogBtn" routerLink="/catalogue/pavilion-list">कॅटलॉग पहा</a>
                                    </div>
                                    <div class="linear-slider">
                                        <div class="slider-track" #sliderTrack>
                                            <!-- First set -->
                                            <div class="slide" *ngFor="let logo of logos">
                                                <img [src]="logo.img" alt="logo" />
                                            </div>
                                            <!-- Duplicate set for seamless looping -->
                                            <div class="slide" *ngFor="let logo of logos">
                                                <img [src]="logo.img" alt="logo" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row grp">
                    <div class="col-md-6">
                        <div class="sec area">
                            <img src="/assets/images/me/ground_icon.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">७३,००० चौ.मी. क्षेत्रफळ</h5>
                            <!-- <img src="/assets/images/me/map_animation.gif" alt="icon" /> -->
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec two">
                            <img src="/assets/images/me/stall_space.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">२६,००० चौ.मी. प्रदर्शन क्षेत्र</h5>
                            <p>आधुनिक कृषी यंत्रांचे लाईव्ह डेमो अनुभवा</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec two">
                            <img src="/assets/images/me/parking.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">५०,००० चौ.मी. पार्किंग</h5>
                            <p>सुलभ वाहतुक व्यवस्था आणि प्रशस्त पार्किंग </p>
                        </div>
                    </div>
                </div>

                <div class="actBtn text-center mt-4 d-flex justify-content-center align-items-center flex-column flex-md-row">
                    <a class="button" (click)="onBuyTickets()" *ngIf="showBuyTicketButton">
                        <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                        तिकीट बुक करा
                        <span><i class="fa fa-arrow-right"></i></span>
                    </a>
                    
                    <a class="button catalogLink"  href="https://pune.kisan.in/detailed-layout" target="_blank">
                        <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                        प्रदर्शनाचा नकाशा
                        <span><i class="fa fa-arrow-right"></i></span>
                    </a>
                </div>

            </div>
        </div>
    </section>


    <section class="ticketSlider d-none">
        <div class="container p-0">
            <h1 class="tit font-weight-600 text-center mb-4">योग्य तिकीट निवडा</h1>
            <div class="slider-container d-none" (mouseenter)="pauseAutoSlide()" (mouseleave)="startAutoSlide()">
                <div class="slider-track">
                    <div class="tkt-slide slide" *ngFor="let slide of slides; let i = index"
                        [ngClass]="slidePositions[i]">
                        <div class="type" [ngClass]="slide.class">
                            <div class="text-center">
                                <img [src]="slide.icon" [alt]="slide.title" />
                                <h3 class="font-weight-600 mt-3 mb-4">{{ slide.title }}</h3>
                            </div>
                            <div class="d-flex align-items-start mt-1" *ngFor="let pt of slide.points">
                                <i class="fa-solid fa-circle-check pt-1"></i>
                                <p class="ms-2">{{ pt }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <div class="slider d-flex flex-column flex-md-row mb-5 justify-content-center">
                <div class="slide d-none">
                    <div class="firstDay type">
                        <div class="text-center">
                            <img src="/assets/images/me/firstday_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">पहिल्या दिवसाचं तिकीट</h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">फक्त पहिल्या दिवसासाठी</p>
                        </div>
                        <!-- <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">सकाळी ९ वाजता शेतकऱ्यांच्या हस्ते होणाऱ्या उद्घाटन सोहळ्यात सहभागी व्हा</p>
                        </div> -->
                        <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">किसान २०२५ प्रदर्शनाला भेट देणाऱ्या पहिल्या काहीजणांपैकी एक व्हा!</p>
                        </div>
                    </div>
                </div>
                <div class="slide">
                    <div class="singleEntry type">
                        <div class="text-center">
                            <img src="/assets/images/me/single_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">एक दिवसीय तिकीट</h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">कोणत्याही एका दिवसासाठी एकदाच प्रवेश</p>
                        </div>
                        <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">प्रदर्शनाच्या कोणत्याही दिवशी भेट देऊ इच्छिणाऱ्यांसाठी</p>
                        </div>
                    </div>
                </div>
                <div class="slide">
                    <div class="allDay type">
                        <div class="text-center">
                            <img src="/assets/images/me/allday_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">सर्व दिवसांचा पास</h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">किसान २०२५ च्या सर्व ५ दिवसांसाठी प्रवेश</p>
                        </div>
                        <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">तुमच्या सोयीप्रमाणे संपूर्ण प्रदर्शन पाहा आणि कोणतीही गोष्ट अनुभवायची राहू देऊ नका!</p>
                        </div>
                    </div>
                </div>
                <div class="slide d-none">
                    <div class="business type">
                        <div class="text-center">
                            <img src="/assets/images/me/business_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">बिझनेस पास</h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">सर्व ५ दिवसांसाठी आणि नेटवर्किंग आणि B2B साठीच्या विशेष दालनामध्ये प्रवेश</p>
                        </div>
                        <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">व्यावसायिक, स्टार्टअप्स आणि उद्योगजगतातील तज्ञांसाठी खास पास</p>
                        </div>
                    </div>
                </div>
                <div class="slide">
                    <div class="child type">
                        <div class="text-center">
                            <img src="/assets/images/me/child_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">मुलांचे तिकीट </h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">एक दिवसीय प्रवेश <br>पालकांसोबत येणे आवश्यक</p>
                        </div>
                        <div class="d-flex align-items-start mt-2">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">पुढच्या पिढीला स्मार्ट शेतीची प्रेरणा द्या</p>
                        </div>
                    </div>
                </div>
                    
                </div>
            <div class="text-center mt-4" *ngIf="showBuyTicketButton">
                <a (click)="onBuyTickets()" class="button">
                    <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                    तिकीट बुक करा
                    <span><i class="fa fa-arrow-right"></i></span>
                </a>
            </div>

            <div style="height: 60px;"></div>
        </div>
    </section>



    <section class="tktStep d-none">
        <div class="container">
            <h1 class="tit font-weight-600 text-center mb-5">तिकीट बुक करण्याची सोपी प्रक्रिया</h1>
            <div class="stepList d-flex flex-column flex-md-row">
                <div class="step">
                    <div class="head d-flex">
                        <div class="num">1</div>
                        <div class="ms-3">
                            <h4 class="font-weight-600">तिकीट निवडा</h4>
                            <p class="mb-4">तुमच्या सोयीप्रमाणे योग्य ते तिकीट निवडा</p>
                        </div>
                    </div>
                    <div class="imageOut">
                        <img class="w-100" src="/assets/images/me/select-tkt.gif" alt="step1" />
                    </div>
                </div>

                <div class="step">
                    <div class="space"></div>
                    <div class="head d-flex">
                        <div class="num">2</div>
                        <div class="ms-3">
                            <h4 class="font-weight-600">तपशील भरा</h4>
                            <p class="mb-4">सुरक्षित आणि झटपट नोंदणी प्रक्रिया</p>
                        </div>
                    </div>
                    <div class="imageOut">
                        <img class="w-100" src="/assets/images/me/assign-tkt.gif" alt="step2" />
                    </div>
                </div>

                <div class="step">
                    <div class="space"></div>
                    <div class="space"></div>
                    <div class="head d-flex">
                        <div class="num">3</div>
                        <div class="ms-3">
                            <h4 class="font-weight-600">QR कोड मिळवा</h4>
                            <p class="mb-4">प्रवेशद्वारावर QR कोड दाखवा आणि प्रदर्शनाचा आनंद घ्या!</p>
                        </div>
                    </div>
                    <div class="imageOut">
                        <img class="w-100" src="/assets/images/me/my-tkt.gif" alt="step3" />
                    </div>
                </div>
            </div>
            <div class="text-center mt-4" *ngIf="showBuyTicketButton">
                <a (click)="onBuyTickets()" class="button">
                    <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                    तिकीट बुक करा
                    <span><i class="fa fa-arrow-right"></i></span>
                </a>
            </div>
        </div>
    </section>

    <section class="location pb-1">
        <div class="container">
            <h1 class="tit font-weight-600 text-center mb-2 pt-2">किसान प्रदर्शनाचा तपशील</h1>
            <div class="imgO">
            <video class="mt-4" #homeVideo autoplay muted loop playsinline preload="auto" width="100%">
                <source src="/assets/images/me/map.mp4" type="video/mp4">
            </video>
                <div class="info">
                    <div>
                        <h3>दिनांक</h3>
                        <h2>९ – १३ डिसेंबर २०२६</h2>
                    </div>
                    <div>
                        <h3>वेळ</h3>
                        <h2>सकाळी ९ ते सायं. ५</h2>
                    </div>
                    <div>
                        <h3>स्थळ</h3>
                        <h2 class="mb-0">PIECC, मोशी, पुणे</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="testimonials">
        <div class="container">
            <h1 class="tit font-weight-600 text-center mb-5">किसानला भेट देणाऱ्यांच्या प्रतिक्रिया</h1>
            <div class="row">
                <!-- <div class="col-sm-3"> </div> -->
                <div class="col-sm-3">
                    <div class="outerTesti">
                        <a href="/assets/images/me/visitor.mp4" target="_blank">
                            <video autoplay muted loop playsinline #homeVideo>
                                <source src="/assets/images/me/visitor.mp4" type="video/mp4">
                            </video>
                        </a>
                        <div class="mt-3 userInfo px-3 d-none">
                            <!-- <h4>रमेश</h4>
                            <h6>शेतकरी</h6> -->
                            <!-- <p>"आम्ही किसान आलो याचा आम्हाला खूप आनंद आहे! तिकीट दर खूपच परवडणारे होते आणि आम्हाला खूप
                                मौल्यवान माहिती मिळाली. धन्यवाद, किसान!"</p> -->
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="outerTesti">
                        <a href="/assets/images/me/exhibitor.mp4" target="_blank">
                            <video autoplay muted loop playsinline #homeVideo>
                                <source src="/assets/images/me/exhibitor.mp4" type="video/mp4">
                            </video>
                        </a>
                        <div class="mt-3 userInfo px-3 d-none">
                            <!-- <h4>अमित ॲग्रीटेक</h4>
                            <h6>स्टार्टअप</h6> -->
                            <!-- <p>किसानने आम्हाला शेतकरी आणि कृषी व्यावसायिकांशी जोडण्यासाठी उत्कृष्ट व्यासपीठ मिळवून दिलं.
                                स्टॉलपासून ते सपोर्टपर्यंत सर्व काही अप्रतिम होतं. </p> -->
                            <!-- व्यवसायासाठी महत्वाच्या लीड्स आणि या सुंदर अनुभवासाठी किसानचे आभार! -->
                        </div>
                    </div>
                </div>
                 <div class="col-sm-3">
                    <div class="outerTesti">
                        <a href="/assets/images/me/visitor_2.mp4" target="_blank">
                            <video autoplay muted loop playsinline #homeVideo>
                                <source src="/assets/images/me/visitor_2.mp4" type="video/mp4">
                            </video>
                        </a>
                        <div class="mt-3 userInfo px-3 d-none">
                            <!-- <h4>रमेश</h4>
                            <h6>शेतकरी</h6> -->
                            <!-- <p>"आम्ही किसान आलो याचा आम्हाला खूप आनंद आहे! तिकीट दर खूपच परवडणारे होते आणि आम्हाला खूप
                                मौल्यवान माहिती मिळाली. धन्यवाद, किसान!"</p> -->
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="outerTesti">
                        <a href="/assets/images/me/Exhi_2.mp4" target="_blank">
                            <video autoplay muted loop playsinline #homeVideo>
                                <source src="/assets/images/me/Exhi_2.mp4" type="video/mp4">
                            </video>
                        </a>
                        <div class="mt-3 userInfo px-3 d-none">
                            <!-- <h4>अमित ॲग्रीटेक</h4>
                            <h6>स्टार्टअप</h6> -->
                            <!-- <p>किसानने आम्हाला शेतकरी आणि कृषी व्यावसायिकांशी जोडण्यासाठी उत्कृष्ट व्यासपीठ मिळवून दिलं.
                                स्टॉलपासून ते सपोर्टपर्यंत सर्व काही अप्रतिम होतं. </p> -->
                            <!-- व्यवसायासाठी महत्वाच्या लीड्स आणि या सुंदर अनुभवासाठी किसानचे आभार! -->
                        </div>
                    </div>
                </div>

                <!-- <div class="col-sm-1"> </div> -->
            </div>
        </div>
    </section>

    <section class="virtual-pass-section pb-5" *ngIf="isContestActive">
        <div class="container">
            <div class="virtual-pass-inner" (click)="onClickVote()">
                <div class="row">
                    <div class="image col-md-5">
                        <!-- <img src="/assets/images/me/Mobile-Pass.png" /> -->
                    </div>
                    <div class="col-md-7">
                        <div class="content">
                            <h1 class="tit pt-1">नव्या शोधांना उत्तेजन द्या</h1>
                            <p class="virtual_description mb-0">
                                ‘किसान क्वेस्ट’ ही स्पर्धा कृषी आणि ग्रामीण जीवनासाठी उपयोगी पडतील 
                                अश्या आधुनिक व व्यावहारिक कल्पना शोधण्यासाठी आयोजित केली होती.
                                ऑनलाईन पद्धतीने मत देऊन भविष्यातील कल्पनांना पाठबळ द्या.
                            </p>
                            <br>
                            <a class="button" (click)="onClickVote()"> 
                                {{ isVotingActive ? 'आपले मत नोंदवा' : 'नव्या कल्पना पाहा' }}  <span><i class="fa fa-arrow-right"></i></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="faq d-none">
        <div class="container">
            <h1 class="tit font-weight-600 text-center mb-5">किसान २०२६ बद्दल सर्व जाणून घ्या!</h1>
            <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            मुलांना प्रवेश आहे का?
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            होय, ५ ते १२ वर्षे वयोगटातील मुले पालकांसोबत प्रवेश करू शकतात.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            पार्किंगची सुविधा आहे का?
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            होय, ५०,००० चौरस मीटरचे स्वतंत्र पार्किंग क्षेत्र उपलब्ध आहे.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            मी माझं तिकीट नंतर अपग्रेड करू शकतो का?
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            होय, कार्यक्रम सुरू होण्यापूर्वी कधीही अपग्रेड करता येईल.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            बिझनेस पासमध्ये काय समाविष्ट आहे?
                        </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            सर्व दिवसांसाठी प्रवेश + व्यावसायिक चर्चांसाठी नेटवर्किंग लाउंजमध्ये प्रवेश.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="footSec d-none">
        <div class="container text-center">
            <h2>आजच तुमच्या भेटीचे नियोजन करा </h2>
            <h2 class="text-white mb-3">भारतातील सर्वात मोठ्या कृषी प्रदर्शनात सहभागी व्हा!</h2>
            <h5>२,००,००० पेक्षा अधिक शेतकरी आणि ६०० पेक्षा अधिक प्रदर्शक आधीच सहभागी होत आहेत — तुम्हीही नक्की या!</h5>
            <div class="text-center mt-4 mb-4" *ngIf="showBuyTicketButton">
                <a (click)="onBuyTickets()" class="button">
                    <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                    तिकीट बुक करा
                    <span><i class="fa fa-arrow-right"></i></span>
                </a>
            </div>
        </div>
    </section>
    <div class="fMenu d-flex align-items-center justify-content-center d-none">
        <div><a href="https://pune.kisan.in/about" target="_blank">किसान बद्दल</a></div>
        <div><a href="https://pune.kisan.in/booknow" target="_blank">प्रदर्शकांसाठी</a></div>
        <div><a href="https://pune.kisan.in/tkt" target="_blank">विशेष ऑफर</a></div>
        <div><a href="https://pune.kisan.in/contact" target="_blank">संपर्क</a></div>
    </div>
</div>